import { useBrandingContext } from '@group-link-one/gl-components';
import type { IBranding } from '@/Branding/_Types/Branding.types';
import { FallbackTemplate } from '@/Templates/FallBack/FallBack.template';
import { useFallBackTemplate } from '@/Templates/FallBack/useFallBack.template';

export const Maintenance = () => {
  const { customLocale } = useFallBackTemplate();

  const { brandingData } = useBrandingContext() as { brandingData: IBranding };

  return (
    <FallbackTemplate
      logoOptions={{
        src: {
          logoLight: brandingData.Onboard.logo,
          logoDark: brandingData.Onboard.logo_dark,
        },
        alt: 'GroupLink logo',
      }}
      title={customLocale('maintanance.title')}
      subtitle={customLocale('maintanance.subtitle')}
      description={customLocale('maintanance.description')}
      hasButton={false}
    />
  );
};
